import { Component } from "@angular/core";

@Component({
  selector: "nw-center",
  templateUrl: "./center.html",
  styleUrls: ["./center.scss"],
})
export class CenterComponent {}
